var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.5C10.5523 18.5 11 18.0523 11 17.5V11.5C11 10.9477 10.5523 10.5 10 10.5C9.44772 10.5 9 10.9477 9 11.5V17.5C9 18.0523 9.44772 18.5 10 18.5ZM20 6.5H16V5.5C16 3.84315 14.6569 2.5 13 2.5H11C9.34315 2.5 8 3.84315 8 5.5V6.5H4C3.44772 6.5 3 6.94772 3 7.5C3 8.05228 3.44772 8.5 4 8.5H5V19.5C5 21.1569 6.34315 22.5 8 22.5H16C17.6569 22.5 19 21.1569 19 19.5V8.5H20C20.5523 8.5 21 8.05228 21 7.5C21 6.94772 20.5523 6.5 20 6.5ZM10 5.5C10 4.94772 10.4477 4.5 11 4.5H13C13.5523 4.5 14 4.94772 14 5.5V6.5H10V5.5ZM17 19.5C17 20.0523 16.5523 20.5 16 20.5H8C7.44772 20.5 7 20.0523 7 19.5V8.5H17V19.5ZM14 18.5C14.5523 18.5 15 18.0523 15 17.5V11.5C15 10.9477 14.5523 10.5 14 10.5C13.4477 10.5 13 10.9477 13 11.5V17.5C13 18.0523 13.4477 18.5 14 18.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default ForwardRef;